import { booleanAttribute, ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';

import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { CustomFormControlComponent } from '../../abstracts/custom-form-control.component';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { MdcFormFieldComponent } from '../mdc-form-field/mdc-form-field.component';

@Component({
  selector: 'mdc-input-chips',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MdcFormFieldComponent, ReactiveFormsModule, MdcFormFieldComponent, MatChipsModule, MatIconModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MdcInputChipsComponent)
    }
  ],
  template: `
    <mdc-form-field [label]="label" [noValidation]="noValidation" [readonly]="readonly" (click)="input.focus()">
      <mat-chip-grid #chipGrid [formControl]="control">
        @for (item of control?.value; track item) {
          <mat-chip-row (removed)="remove(item)" [removable]="true">
            {{ item }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-row>
        }
        <input
          #input
          [matChipInputAddOnBlur]="true"
          [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
          class="keeper-ignore"
          data-lpignore="true" />
      </mat-chip-grid>
    </mdc-form-field>
  `
})
export class MdcInputChipsComponent extends CustomFormControlComponent {
  @Input({ transform: booleanAttribute }) noValidation = false;
  @Input({ transform: booleanAttribute }) readonly = false;
  @Input({ transform: booleanAttribute }) allowDuplicates = false;
  @Input() label = '';

  protected readonly separatorKeysCodes = [ENTER, COMMA, TAB] as const;

  add(event: MatChipInputEvent): void {
    const input = event?.chipInput?.inputElement;
    const newItem = event?.value?.trim() || '';
    const exists = this.control.value?.length && this.control.value.includes(newItem);
    if (newItem.length && (this.allowDuplicates || !exists)) {
      this.control.setValue(this.control.value?.length ? [...this.control.value, newItem] : [newItem]);
      this.control.markAsTouched();
      this.formGroup.updateValueAndValidity();
    }
    if (input) {
      input.value = '';
    }
  }

  remove(item: string): void {
    if (Array.isArray(this.control.value)) {
      this.control.setValue(this.control.value.filter((i) => i !== item));
    } else {
      this.control.setValue('');
    }
    this.control.markAsTouched();
    this.formGroup.updateValueAndValidity();
  }
}
